import { z } from "zod";

/** T-051 — CSAT (tasks/W4-CONTRACTS.md §5) */

export const CsatScale = z.enum(["1-5", "emoji-3", "nps-10"]);
export type CsatScale = z.infer<typeof CsatScale>;

/** POST /api/v1/my/tickets/:id/csat — portal rating (requester session) */
export const CsatSubmit = z.object({
  score: z.number().int(),
  comment: z.string().max(5000).optional(),
});
export type CsatSubmit = z.infer<typeof CsatSubmit>;

/** POST /api/v1/csat/:token/comment — คอมเมนต์ต่อท้าย one-click rating */
export const CsatCommentInput = z.object({
  comment: z.string().min(1).max(5000),
});
export type CsatCommentInput = z.infer<typeof CsatCommentInput>;

export const CsatResponse = z.object({
  ticket_id: z.string(), // public id
  score: z.number().int(),
  scale: z.string(),
  comment: z.string().nullable(),
  channel: z.enum(["email", "portal", "api"]),
  created_at: z.iso.datetime(),
});
export type CsatResponse = z.infer<typeof CsatResponse>;

/** GET /api/v1/csat/stats */
export const CsatStatsQuery = z.object({
  team_id: z.uuid().optional(),
  service_id: z.uuid().optional(),
  since: z.iso.datetime().optional(),
  until: z.iso.datetime().optional(),
});
export type CsatStatsQuery = z.infer<typeof CsatStatsQuery>;

export const CsatStats = z.object({
  count: z.number().int(),
  avg: z.number().nullable(),
  distribution: z.record(z.string(), z.number().int()),
  by_agent: z.array(z.object({ user_id: z.uuid(), count: z.number().int(), avg: z.number() })),
});
export type CsatStats = z.infer<typeof CsatStats>;
